import SidePanelHeader from "../components/SidePanelHeader"
import SidePanelBreadCrumb from "../components/SidePanelBreadCrumb"
import { useParams } from "react-router"
import { httpGet, httpPost } from "../../../../../modules/Backend"
import { useEffect, useState } from "react"
import { EntityNames } from "../../../../../enums/EntityNames";
import { globalSubmittingSignal, movingSidePanelSignal } from "../../Layout";
import { Button } from "react-aria-components";
import { modalSignal } from "../../../Modal/ModalContainer";
import { HttpStatusCode } from "axios";
import { useSignals } from "@preact/signals-react/runtime";
import SidePanelOuterCubeMaterial from "../components/SidePanelOuterCubeMaterial";
import SidePanelInfo from "../components/SidePanelInfo";
import ConfirmModal from "../../../Modal/ConfirmModal"

export default function SidePanelPartFullOuterCube({ data, onViewPage }: any) {
    useSignals();

    const { entityId } = useParams();
    const [location, setLocation] = useState<string>("")
    const [hasOuterCube, setHasOuterCube] = useState<boolean | undefined>(undefined);

    async function getLocation() {
        const result = await httpGet(`api/${EntityNames.outerCubes}/location?id=${data.id}`)
        if (result?.data?.breadcrumb) {
            setLocation(result.data.breadcrumb)
        }
    }

    async function assignPalletToWorkstation() {
        globalSubmittingSignal.value = { isBusy: true };
        const result = await httpPost(`api/${EntityNames.partFullOuterCubes}/assignToWorkstation`,
        {
            outerCubeId: data.id,
            workstationLocationId: entityId
        })
        if (result.status === HttpStatusCode.Ok) {
            modalSignal.value = undefined
            window.location.hash = '0';
            movingSidePanelSignal.value = { id: undefined, show: false, component: undefined }
        }
        globalSubmittingSignal.value = { isBusy: false };
    }

    function handleAssignToWorkstation() {
        modalSignal.value = <ConfirmModal
            heading={`Move pallet to your workstation?`}
            information=""
            ContinueFunc={assignPalletToWorkstation} />
    }

    useEffect(() => {
        data.currentLocation ? setLocation(data.currentLocation) : getLocation()
    }, [data])

    useEffect(() => {
        async function getWorkstationData() {
            const result = await httpGet(`api/${EntityNames.workstations}/get?id=${entityId}`);
            if(result.status === HttpStatusCode.Ok) {
                setHasOuterCube(result.data.hasOuterCube);
            }   
        }
        if(entityId) {
            getWorkstationData();
        }
    }, [entityId])

    return (<>
        {data &&
            <>
                {!onViewPage && <SidePanelHeader descriptor="Part Full Pallet" value={data.reference} statuses={data.status} onClick={undefined} />}
                <div className="display--flex flex__wrap--wrap margin__top--s justifyContent--space-between">
                    <div className="display--flex width--full">
                        {!onViewPage && data && hasOuterCube &&
                            <div className="box box--warning width--full">
                                <p>This workstation is occupied, clear it to request another pallet</p>
                            </div>
                        }
                        {data && hasOuterCube === false &&
                            <Button isDisabled={globalSubmittingSignal.value.isBusy} className={"button button--small button--primary button--secondary--primary button--with-icon"} onPress={handleAssignToWorkstation}>
                                <p className="button-text">Assign to your workstation</p>
                            </Button>
                        }
                    </div>
                </div>
                <SidePanelInfo values={[
                    { label: "Reference number", value: data.reference },
                    { label: "Belongs to", value: data.belongsTo },
                    { label: "Type", value: data.type },
                ]} />
                <SidePanelBreadCrumb descriptor="Current Location" value={location} />
                <SidePanelOuterCubeMaterial data={data} />
            </>
        }
    </>)
}